const Urler = (domainEndpoint) => {
  // Use NGINX reverse proxy (port 80) which routes /api/* to main-api
  const mainDomain = process.env.REACT_APP_API_URL || "http://localhost";
  const mainEndpoint = "/api/league_of_gamers_api/level5";

  const fullPath = `${mainEndpoint}/${domainEndpoint}`.replace(/\/+/g, "/");
  return `${mainDomain}${fullPath}`;
};

export default Urler;
